import React from "react";

import Doctor from "../../../assets/images/Icons/Doctor.svg";

//Style
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import "./SideBarRight.scss";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

const SideBarRight = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <section className="side-rigth px-3">
      <MDBListGroup>
        <MDBListGroupItem>
          <img src={Doctor} className="d-inline-inline mx-3" alt={"Home"} />
          <p>{state?.doctors}</p>
        </MDBListGroupItem>
        <MDBListGroupItem className="active">
          <p>{state?.allDoctors}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.surggery}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.dentistry}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.cardiology}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.neurology}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.infectiusDieseases}</p>
        </MDBListGroupItem>
        <MDBListGroupItem className="more">
          <p>{state?.showMore}</p>
        </MDBListGroupItem>
      </MDBListGroup>

      <MDBListGroup>
        <MDBListGroupItem>
          <p>{state?.filter}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.gender}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <div className="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" className="custom-control-input" id="all" />
            <label className="custom-control-label" for="all">
              {state?.الكل}
            </label>
          </div>

          <div className="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" className="custom-control-input" id="male" />
            <label className="custom-control-label" for="male">
              {state?.male}
            </label>
          </div>

          <div className="custom-control custom-checkbox custom-control-inline">
            <input
              type="checkbox"
              className="custom-control-input"
              id="female"
            />
            <label className="custom-control-label" for="female">
              {state?.female}
            </label>
          </div>
        </MDBListGroupItem>
      </MDBListGroup>
    </section>
  );
};
export default SideBarRight;
